import { Injectable, Inject } from '@angular/core';
import { Environment } from '../classes/environment';
import { User } from '../classes/user';

/*
	this service is independent from AuthenticationService to avoid circular dependencies
*/

@Injectable({ providedIn: 'root' })
export class CurrentUserService {


	constructor(
		@Inject('environment') private environment: Environment,
		@Inject('LOCALSTORAGE') private localStorage: Storage,
	) {}

	
	currentUser(): User|null {

		const strCurrentUser = this.localStorage.getItem( 'currentUser' );
		if( !strCurrentUser ) return null;

		try {

			const user = JSON.parse( strCurrentUser );
			if( !user || !user.gruppen || !user.gruppen.length ) return null;

			return user;

		}
		catch( e ) {
			return null;
		}

	}

	isCurrentUserAdmin(): boolean {

		if( this.environment.offlineMode && this.environment.offlineModeAdmin ) return true;

		const user = this.currentUser();
		if( !user || !user.gruppen || !user.gruppen.length ) return false;

		return user.gruppen.includes( 'ADMIN' );

	}

}


